import { useState, type FormEvent } from 'react';
import { Navigate } from 'react-router-dom';
import { ApiError } from '@/lib/api';
import { Button } from '@/components/ui/Button';
import { Field, Input } from '@/components/ui/Input';
import { Sweep } from '@/components/ui/States';
import { useLogin, useSession } from './session';

export function LoginPage() {
  const session = useSession();
  const login = useLogin();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  if (session.data) return <Navigate to="/feed" replace />;

  const submit = (event: FormEvent) => {
    event.preventDefault();
    login.mutate({ email, password });
  };

  const message =
    login.error instanceof ApiError
      ? login.error.message
      : login.error
        ? 'Could not reach the server.'
        : null;

  return (
    <div className="flex min-h-dvh items-center justify-center p-6">
      <div className="w-full max-w-sm">
        <div className="mb-8 text-center">
          <h1 className="font-mono text-lg font-medium tracking-[0.3em] text-ink">BIG BROTHER</h1>
          <p className="label-xs mt-2">Signals console &middot; restricted</p>
        </div>

        <form
          onSubmit={submit}
          className="flex flex-col gap-4 border border-line bg-panel/85 p-6 backdrop-blur-[1px]"
        >
          <Field label="Operator">
            <Input
              type="email"
              autoComplete="username"
              required
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              placeholder="you@example.com"
            />
          </Field>

          <Field label="Passphrase">
            <Input
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              placeholder="••••••••••••"
            />
          </Field>

          {message ? (
            <p className="border border-alert/40 bg-alert-dim px-2.5 py-2 font-mono text-[11px] text-alert">
              {message}
            </p>
          ) : null}

          <Button type="submit" variant="primary" disabled={login.isPending} className="mt-1">
            {login.isPending ? 'Authenticating' : 'Authenticate'}
          </Button>

          {login.isPending ? <Sweep /> : <div className="h-px" />}
        </form>

        <p className="mt-4 text-center font-mono text-[10px] leading-relaxed text-ink-faint">
          No self-service enrolment. Accounts are provisioned with
          <span className="text-ink-dim"> pnpm user:create</span>.
        </p>
      </div>
    </div>
  );
}
